import { render } from "./RegistroReferido.vue?vue&type=template&id=09d14634"
import script from "./RegistroReferido.vue?vue&type=script&lang=js"
export * from "./RegistroReferido.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__